export default __webpack_public_path__ + "static/media/diet.8bfb7c8b.png";